import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Box,
  Pagination,
  Tooltip,
  Typography,
  Collapse,
  IconButton
} from '@mui/material';
import palette from 'src/theme/palette';
import { TableNoData } from 'src/components/NoData';
import Iconify from 'src/components/Iconify';
import { LoadingButton } from '@mui/lab';
import AddEditSubProjectModal from './AddEditSubProjectModal';
import { toast } from 'react-toastify';
import { api } from 'src/Api';
import SubProjectDialog from './SubProjectDialog';
import TaskTable from './TaskTable';
import DeleteModal from 'src/components/DeleteModal';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';
import AddEditTaskModal from './AddEditTaskModal';
import ProjectManagerDropdown from 'src/components/ProjectManagerDropdown';

const SubProjectTable = ({
  data,
  loading,
  permission,
  handlePageChange,
  pagination,
  refresh,
  projectData
}) => {
  const [editingData, setEditingData] = useState(null);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showProjectDetailModal, setShowProjectDetailModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const [expandedRow, setExpandedRow] = useState(null);
  const [selectedRow, setSelectedRow] = useState('');

  useEffect(() => {
    if (loading) {
      handleCloseExpendData();
    }
  }, [loading]);

  const handleToggle = (index, row) => {
    setExpandedRow((prev) => (prev === index ? null : index));
    setSelectedRow(row);
  };

  const handleCloseExpendData = () => {
    setSelectedRow('');
    setExpandedRow(null);
  };

  const handleEditSubProject = (row) => {
    setEditingData(row);
    setShowAddEditModal(true);
  };

  const handleDeleteModal = (id) => {
    setSelectedProject(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setSelectedProject(null);
    setShowDeleteModal(false);
  };

  function handleDeleteSubProject() {
    setStatusLoading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const queryParams = new URLSearchParams();
    queryParams.append('id', selectedProject);

    const requestOptions = {
      method: 'DELETE',
      redirect: 'follow',
      headers: myHeaders
    };

    fetch(`${api.delete_sub_project}?${queryParams}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          handleCloseDeleteModal();
          toast.success(result.message);
          handleCloseExpendData();
          refresh();
        } else {
          toast.error(result.error);
        }
      })
      .catch((error) => {
        toast.error(error.error);
        console.log('error', error);
      })
      .finally(() => {
        setStatusLoading(false);
      });
  }

  const handleUserClick = (row) => {
    setShowProjectDetailModal(true);
    setSelectedProject(row);
  };

  const hasSubProjectAction =
    permission.includes('edit sub project') ||
    permission.includes('add task') ||
    permission.includes('delete sub project');

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: '1px 2px 13px 0px rgba(0,0,0,0.2)',
          width: '100%',
          position: 'relative',
          minHeight: 300
        }}
      >
        {/* {loading && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              minHeight: 250,
              background: 'rgba(255,255,255,0.7)',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <CircularProgress size={48} />
          </Box>
        )} */}
        <Table stickyHeader sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow sx={{ borderBottom: '1.5px solid #E5E7EB' }}>
              {/* Sub Project Name */}
              <TableCell
                sx={{
                  fontSize: 12,
                  color: palette.primary.tableHeadTitle,
                  fontFamily: 'poppinsThin',
                  pl: 1,
                  width: '30%' // 🔹 flexible width
                }}
              >
                Sub Project Name
              </TableCell>

              {/* Description */}
              <TableCell
                sx={{
                  fontSize: 12,
                  color: palette.primary.tableHeadTitle,
                  fontFamily: 'poppinsThin',
                  pl: 1,
                  width: '30%' // 🔹 flexible width
                }}
              >
                Description
              </TableCell>

              {/* Task count */}
              <TableCell
                sx={{
                  fontSize: 12,
                  color: palette.primary.tableHeadTitle,
                  fontFamily: 'poppinsThin',
                  pl: 1,
                  width: '30%'
                }}
              >
                Tasks
              </TableCell>

              {/* Action */}
              {hasSubProjectAction && (
                <TableCell
                  sx={{
                    fontSize: 12,
                    color: palette.primary.tableHeadTitle,
                    fontFamily: 'poppinsThin',
                    pl: 1,
                    pr: 0,
                    position: { xs: 'static', md: 'sticky' },
                    right: { xs: 'auto', md: 0 },
                    zIndex: 3,
                    backgroundColor: { md: '#fff' },
                    whiteSpace: 'nowrap'
                  }}
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          {/* {!loading && ( */}
          <TableBody>
            {data.map((row, index) => (
              <>
                <TableRow key={index} sx={{ borderBottom: '1.5px solid #E5E7EB' }}>
                  {/* SUB PROJECT NAME */}
                  <TableCell sx={{ pl: 0 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {/* 🔹 Toggle Icon */}
                      <IconButton
                        size="small"
                        onClick={() => handleToggle(index, row)}
                        sx={{ mx: 0.5 }}
                      >
                        {expandedRow === index ? (
                          <Iconify
                            icon="iconamoon:arrow-down-2-light"
                            sx={{
                              color: '#000'
                            }}
                          />
                        ) : (
                          <Iconify
                            icon="iconamoon:arrow-right-2-light"
                            sx={{
                              color: '#000'
                            }}
                          />
                        )}
                      </IconButton>

                      <Typography
                        sx={{
                          fontSize: 12,
                          fontFamily: 'poppinsRegular',
                          color: palette.primary.main,
                          cursor: 'pointer',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: 'block',
                          maxWidth: '170px',
                          '&:hover': {
                            textDecoration: 'underline',
                            color: palette.primary.mainDark
                          }
                        }}
                        onClick={() => handleUserClick(row)}
                      >
                        {row?.name || 'N/A'}
                      </Typography>
                    </Box>
                  </TableCell>

                  {/* Description */}
                  <TableCell
                    sx={{
                      fontSize: 12,
                      fontFamily: 'poppinsMedium',
                      pl: 1,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {row?.description || 'N/A'}
                  </TableCell>

                  {/* TASKS COUNT */}
                  <TableCell
                    sx={{
                      fontSize: 12,
                      fontFamily: 'poppinsMedium',
                      pl: 1
                    }}
                  >
                    {row?.sub_project_task_count || 'N/A'}
                  </TableCell>

                  {/* ACTIONS */}
                  {hasSubProjectAction && (
                    <TableCell
                      sx={{
                        fontSize: 12,
                        fontFamily: 'poppinsMedium',
                        pl: 1,
                        pr: 2,
                        position: { xs: 'static', md: 'sticky' },
                        right: { xs: 'auto', md: 0 },
                        zIndex: 2,
                        backgroundColor: '#fff',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {permission.includes('edit sub project') && (
                        <Tooltip title="Edit">
                          <span>
                            <LoadingButtonWrapper
                              variant="contained"
                              sx={{
                                width: 60,
                                height: 30,
                                fontSize: 10,
                                borderRadius: 0.7,
                                fontFamily: 'poppinsLight',
                                letterSpacing: 0.3,
                                minWidth: 10,
                                marginRight: 0.5,
                                paddingRight: 0,
                                paddingLeft: 0,
                                paddingTop: 0,
                                paddingBottom: 0,
                                transition:
                                  'width 0.3s ease, background-color 0.3s ease, transform 0.3s ease'
                              }}
                              title="Edit"
                              onClick={() => handleEditSubProject(row)}
                              startIcon={
                                <Iconify
                                  style={{
                                    cursor: 'pointer',
                                    fontSize: 15,
                                    color: '#ffffff'
                                  }}
                                  icon="cuida:edit-outline"
                                />
                              }
                            />
                          </span>
                        </Tooltip>
                      )}

                      {permission.includes('add task') && (
                        <Tooltip title="Add Task">
                          <span>
                            <LoadingButtonWrapper
                              variant="contained"
                              sx={{
                                width: 80,
                                height: 30,
                                fontSize: 10,
                                borderRadius: 0.7,
                                fontFamily: 'poppinsLight',
                                letterSpacing: 0.3,
                                minWidth: 10,
                                marginRight: 0.5,
                                paddingRight: 0,
                                paddingLeft: 0,
                                paddingTop: 0,
                                paddingBottom: 0,
                                transition:
                                  'width 0.3s ease, background-color 0.3s ease, transform 0.3s ease'
                              }}
                              title="Add Task"
                              onClick={() => {
                                setShowTaskModal(true);
                                setEditingData(row);
                              }}
                              startIcon={
                                <Iconify
                                  style={{
                                    cursor: 'pointer',
                                    fontSize: 18,
                                    color: '#ffffff',
                                    marginRight: -5
                                  }}
                                  icon="material-symbols:add-rounded"
                                />
                              }
                            />
                          </span>
                        </Tooltip>
                      )}

                      {permission.includes('delete sub project') && (
                        <Tooltip title="Delete">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            sx={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              p: 0,
                              alignSelf: 'center',
                              mr: 1,
                              borderRadius: 1,
                              backgroundColor: '#f72929ff',
                              ':hover': {
                                backgroundColor: '#cb2020ff'
                              }
                            }}
                            onClick={() => handleDeleteModal(row?.id)}
                          >
                            <Iconify
                              sx={{
                                cursor: 'pointer',
                                fontSize: 21,
                                color: '#ffffff'
                              }}
                              icon="material-symbols-light:delete-rounded"
                            />
                          </LoadingButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  )}
                </TableRow>

                {/* 🔹 Collapsible Row */}
                <TableRow>
                  <TableCell colSpan={4} sx={{ p: 0, border: 0 }}>
                    <Collapse in={expandedRow === index} timeout="auto" unmountOnExit>
                      <TaskTable
                        expandedRow={expandedRow}
                        index={index}
                        selectedData={selectedRow}
                        permission={permission}
                      />
                    </Collapse>
                  </TableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
          {/* )} */}

          {/* Empty State */}
          {data?.length === 0 && !loading && <TableNoData colSpan={16} />}
        </Table>

        {/* PAGINATION */}
        {!loading && pagination.last_page > 1 && data.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
            my={1}
            px={2}
          >
            <Pagination
              count={pagination.last_page}
              page={pagination.current_page}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        )}
      </TableContainer>

      {/* DETAILS MODAL */}
      <SubProjectDialog
        open={showProjectDetailModal}
        onClose={() => {
          setShowProjectDetailModal(false);
          setSelectedProject(null);
        }}
        subProject={selectedProject}
      />

      {/* DELETE SUB PROJECT MODAL */}
      <DeleteModal
        open={showDeleteModal}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDeleteSubProject}
        loading={statusLoading}
        title="Delete Sub Project"
        description={'Are you sure you want to delete this Sub Project'}
      />

      {/* EDIT MODAL */}
      <AddEditSubProjectModal
        open={showAddEditModal}
        onClose={() => {
          setShowAddEditModal(false);
          setEditingData(null);
        }}
        refresh={refresh}
        initialData={editingData}
        projectData={projectData}
      />

      {/* ADD TASK MODAL */}
      <AddEditTaskModal
        open={showTaskModal}
        onClose={() => {
          setShowTaskModal(false);
          setEditingData(null);
        }}
        refresh={refresh}
        sub_project_id={editingData?.id}
        project_id={editingData?.project_id}
      />
    </>
  );
};

export default SubProjectTable;
